import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Table,
  Spin,
  Select,
  Divider,
  List,
  Form,
  Button,
  Modal,
  Tag,
} from "antd";
import {
  CheckOutlined,
  ReloadOutlined,
  ExclamationCircleOutlined,
  SafetyOutlined,
  ExclamationOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../configurations/configurations.config";
import CustomButton from "../../../components/custom/CustomButton";

const handleFlgStatus = (status, style = {}, isListing = false) => {
  switch (status.toLowerCase()) {
    case "success":
      return (
        <Tag
          icon={<CheckCircleOutlined />}
          color={`${isListing ? "success" : "#87D068"}`}
          style={style}
        >
          {status}
        </Tag>
      );
    case "failed":
      return (
        <Tag
          icon={<CloseCircleOutlined />}
          color={`${isListing ? "red" : "#FA0008"}`}
          style={style}
        >
          {status}
        </Tag>
      );
    default:
      return (
        <Tag
          icon={<ClockCircleOutlined />}
          color={`${isListing ? "warning" : "#FFEB86"}`}
          style={{ color: "black", ...style }}
        >
          {BOM.SubstringFormat(status, 21)}
        </Tag>
      );
  }
};

const ManageSchedulerJobs = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [jobsData, setJobsData] = useState([]);
  const [scheduler, setScheduler] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [jobsTemplate, setJobsTemplate] = useState([]);
  const childref = useRef();

  //DECLARED METHODS
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setJobsData(originalList);
      return;
    }

    const filterBySearch = originalList.filter((item) =>
      item?.name?.toLowerCase().includes(searchKey)
    );

    setJobsData(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  //END METHODS DECLARED

  useEffect(() => {
    getJobs();
    getScheduler();
  }, []);

  const getJobs = () => {
    console.log("logging...jobs");
    let body = {
      session,
    };
    setIsLoading(false);
    BOM.FetchReqAction(body, apiConfig.Jobs, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        setJobsTemplate(objList);
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.jobId,
            id: element.jobId,
            name: element.displayName,
            nextRun: element.nextRunTime,
            prevRun: element.lastRunHistory
              ? element.lastRunHistory?.jobRunStartTime
              : "-",
            prevRunStatus: element?.lastRunHistory?.status || "-",

            currentRunning: element.currentlyRunning ? "Yes" : "No",
            errorLog: element.lastRunHistory
              ? element.lastRunHistory?.jobRunErrorLog
              : "-",
          });
        });

        setJobsData(tempArray);
        setOriginalList(tempArray);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, apiConfig.Jobs, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          setJobsTemplate(objList);
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.jobId,
              id: element.jobId,
              name: element.displayName,
              nextRun: element.nextRunTime,
              prevRun: element.lastRunHistory
                ? element.lastRunHistory?.jobRunStartTime
                : "-",
              prevRunStatus: element?.lastRunHistory?.status || "-",
              currentRunning: element.currentlyRunning ? "Yes" : "No",
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  function getScheduler() {
    const url = `${apiConfig.Scheduler}`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false);
        const objList = res;
        setScheduler(objList);
      }
    });
  }

  const onSelectItemAction = (selectedKeys, selectedRows) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRowKeys(selectedKeys);
    setSelectedRow(selectedRows);

    if (selectedKeys.length === 1) {
      [cnt.RIGHT_DETAIL_BTN].map((item) => {
        dispatch({ type: item });
      });
      BOM.HasPermission("UPDATE_SCHEDULER") &&
        dispatch({ type: cnt.RIGHT_EDIT_BTN });
      BOM.HasPermission("EXECUTEJOB_SCHEDULER") &&
        dispatch({ type: cnt.RIGHT_RUN_BTN });
    } else if (selectedKeys.length > 1) {
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });
      BOM.HasPermission("EXECUTEJOB_SCHEDULER") &&
        dispatch({ type: cnt.RIGHT_RUN_BTN });
    } else {
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectItemAction,
    selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
  };

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-scheduler-jobs", {
        state: { id: selectedRow[0].id },
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-scheduler-jobs", {
        state: { id: selectedRow[0].id },
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleRun() {
    setIsLoading(true);

    const params = { command: "executeJob" };

    try {
      if (selectedRow.length === 1) {
        // Single row submission
        let body = {
          method: "POST",
          session,
          params,
        };

        const url = `${apiConfig.Jobs}/${selectedRow[0].id}`;

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            childref?.current?.showModal();
            //STOP LOAD
            setIsLoading(false);
          }
        });
      } else {
        // Batch submission (2 or more rows)
        selectedRow.map((row) => {
          let body = {
            method: "POST",
            session,
            params,
          };

          const url = `${apiConfig.Jobs}/${row.id}`;

          return BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
              childref?.current?.showModal();
              //STOP LOAD
              setIsLoading(false);
            } else {
              childref?.current?.showModal();
              //STOP LOAD
              setIsLoading(false);
            }
          });
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  function handleErrorModal() {
    setIsErrorModalOpen(true);
  }

  function handleRefresh() {
    window.location.reload();
  }

  function handleActivateSuspend() {
    const params = {
      command: scheduler.active ? "stop" : "start",
    };

    const url = `${apiConfig.Scheduler}`;

    let body = {
      session,
      params,
      method: "POST",
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        getScheduler();
        setIsLoading(false);
      }
    });
  }

  const columns = [
    {
      title: labelConfig.id,
      dataIndex: "id",
    },
    {
      title: labelConfig.name,
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultSortOrder: "ascend",
    },
    {
      title: labelConfig.nextRun,
      dataIndex: "nextRun",
    },
    {
      title: labelConfig.prevRun,
      dataIndex: "prevRun",
    },

    {
      title: labelConfig.prevRunStatus,
      dataIndex: "prevRunStatus",
      render: (status) => {
        if (status === "-") return status;
        return handleFlgStatus(status, {}, true);
      },
    },

    {
      title: labelConfig.currentRunning,
      dataIndex: "currentRunning",
    },

    {
      title: labelConfig.errorLog,
      dataIndex: "errorLog",
      render: (_, record) =>
        record?.errorLog !== undefined && (
          <ErrorLogModal
            userData={userData}
            ref={childref}
            selectedRow={selectedRow}
            isErrorModalOpen={isErrorModalOpen}
            setIsErrorModalOpen={setIsErrorModalOpen}
            handleErrorModal={handleErrorModal}
            errorData={record?.errorLog}
          />
        ),
    },
  ];

  const csvColumns = [
    {
      title: labelConfig.id,
      dataIndex: "id",
    },
    {
      title: labelConfig.name,
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultSortOrder: "ascend",
    },
    {
      title: labelConfig.nextRun,
      dataIndex: "nextRun",
    },
    {
      title: labelConfig.prevRun,
      dataIndex: "prevRun",
    },

    {
      title: labelConfig.prevRunStatus,
      dataIndex: "prevRunStatus",
      render: (status) => {
        if (status === "-") return status;
        return handleFlgStatus(status, {}, true);
      },
    },

    {
      title: labelConfig.currentRunning,
      dataIndex: "currentRunning",
    },
  ];

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onEdit={handleOnEdit}
      onRun={handleRun}
    >
      <TopContent
        pageTitle={labelConfig.schedulerJobs}
        pageItems={staticConfig.schedulerJobsBreadcrumbItems}
      />

      <Card
        title={
          <>
            {labelConfig.schedulerJobs} List &nbsp;
            <Button
              type="primary"
              shape="round"
              size="small"
              className="of-primaryBtnColor"
              onClick={handleRefresh}
              icon={<ReloadOutlined />}
              loading={isLoading}
            >
              {labelConfig.refresh}
            </Button>
            &nbsp;
            {BOM.HasPermission("UPDATE_SCHEDULER") && (
              <Button
                type="primary"
                shape="round"
                size="small"
                className="of-primaryBtnColor"
                onClick={handleActivateSuspend}
                icon={
                  scheduler.active ? (
                    <ExclamationCircleOutlined />
                  ) : (
                    <CheckOutlined />
                  )
                }
                loading={isLoading}
              >
                {scheduler.active ? labelConfig.suspend : labelConfig.activate}
              </Button>
            )}
            &nbsp;
            <Tag
              icon={<SafetyOutlined />}
              color={`${!scheduler?.active ? "warning" : "green"}`}
            >
              {scheduler?.active ? "Active" : "Standby"}
            </Tag>
          </>
        }
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/*RENDER TABLE LIST HERE*/}

        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name..."
                style={{
                  width: 400,
                }}
              />
            </div>
            <DownloadTableButtons
              downloadData={jobsData}
              columns={csvColumns}
              fileName={"Scheduler Jobs List"}
              onExportClick={getCsvListData}
            />
          </Row>
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={jobsData}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
          <Row>
            <RunSchedulerJobs
              userData={userData}
              ref={childref}
              selectedRow={selectedRow}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
            />
          </Row>
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageSchedulerJobs);

const RunSchedulerJobs = forwardRef((props, ref) => {
  const { isModalOpen, setIsModalOpen, selectedRow } = props;

  const [useForm] = Form.useForm();

  // MODAL VARIABLES

  useImperativeHandle(ref, () => ({
    showModal() {
      setIsModalOpen(true);
    },
  }));

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Row>
      <Modal
        title="Jobs Sent for Execution"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={1000}
        styles={{
          body: { overflowY: "auto", maxHeight: "calc(100vh - 300px)" },
        }}
      >
        <Form form={useForm} layout="vertical">
          <Divider />

          {selectedRow?.length > 0 && (
            <List
              itemLayout="horizontal"
              dataSource={selectedRow}
              renderItem={(item, index) => (
                <Card style={{ width: "100%", marginBottom: 20 }}>
                  <List.Item
                    actions={[
                      <Button
                        type="primary"
                        shape="round"
                        size="small"
                        icon={<CheckOutlined />}
                        style={{
                          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                          marginLeft: "auto",
                          backgroundColor: "#87d068",
                        }}
                      >
                        Active
                      </Button>,
                    ]}
                  >
                    <List.Item.Meta title={item.name} />
                  </List.Item>
                </Card>
              )}
            />
          )}

          <Row>
            <Divider />
            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "auto",
                marginRight: "3%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={() => setIsModalOpen(false)}
            />
          </Row>
        </Form>
      </Modal>
    </Row>
  );
});

export const ErrorLogModal = (props) => {
  const { isErrorModalOpen, setIsErrorModalOpen, errorData, handleErrorModal } =
    props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsErrorModalOpen(true);
  };

  const handleCancel = () => {
    setIsErrorModalOpen(false);
  };

  return (
    <Row>
      <Button
        type="primary"
        shape="round"
        size="small"
        className="of-primaryBtnColor"
        onClick={handleErrorModal}
        icon={<ExclamationOutlined />}
        style={{ backgroundColor: "#92428B", color: "white", width: "10vh" }}
      >
        View
      </Button>

      <Modal
        title="Error Log"
        open={isErrorModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={1000}
        styles={{
          body: { overflowY: "auto", maxHeight: "calc(100vh - 300px)" },
        }}
      >
        <Form form={useForm} layout="vertical">
          {errorData}
          <Row>
            <Divider />

            <CustomButton
              content="send Report"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                padding: "0px 50px 0px 50px",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              // onClick={() => setIsErrorModalOpen(false)}
            />
            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={() => setIsErrorModalOpen(false)}
            />
          </Row>
        </Form>
      </Modal>
    </Row>
  );
};
